<div id="invoice" class="compact page-layout blank" fxLayout="column">
    <div class="invoice-container">
        <div>
            <div>
                <td style="float:left">
                    <h1 style="font-weight: bold;"> Distribution Manifest </h1>
                    <h3> Date : {{today}} </h3>
                </td>
                <td style="float:right">
                    <h4> Sender: {{distribution.shipper.fullName}} </h4>
                    <h4> Origin: {{distribution.shipper.address.cityName}} </h4>
                </td>
            </div>
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="label">
                    <th mat-header-cell *matHeaderCellDef> Label</th>
                    <td mat-cell *matCellDef="let element">
                        <ngx-barcode [bc-value]="element.label" [bc-height]="30" [bc-width]="2.5"
                            [bc-display-value]="true"></ngx-barcode>
                    </td>
                </ng-container>
                <ng-container matColumnDef="receiver">
                    <th mat-header-cell *matHeaderCellDef> Receiver </th>
                    <td mat-cell *matCellDef="let element"> {{element.receiver}} </td>
                </ng-container>
                <ng-container matColumnDef="destination">
                    <th mat-header-cell *matHeaderCellDef> Destination </th>
                    <td mat-cell *matCellDef="let element"> {{element.destination}} </td>
                </ng-container>
                <ng-container matColumnDef="weight">
                    <th mat-header-cell *matHeaderCellDef> Weight </th>
                    <td mat-cell *matCellDef="let element"> {{element.weight}} </td>
                </ng-container>
                <ng-container matColumnDef="nop">
                    <th mat-header-cell *matHeaderCellDef> Nop </th>
                    <td mat-cell *matCellDef="let element"> {{element.nop}} </td>
                </ng-container>
                <ng-container matColumnDef="shipmentValue">
                    <th mat-header-cell *matHeaderCellDef> Goods Value </th>
                    <td mat-cell *matCellDef="let element"> {{element.shipmentValue}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>



            <!-- Copyright 2018 Google Inc. All Rights Reserved.
                  Use of this source code is governed by an MIT-style license that
                  can be found in the LICENSE file at http://angular.io/license -->
            <!-- <tr>
                <td>
                    <h2>{{distribution.shipper.fullName}}</h2>
                </td>
            </tr> -->
            <!-- <tr>
                <td>
                    <div class="invoice-number" fxLayout="row" fxLayoutAlign="start start">
                        <div> Receiver </div>
                        <div> Receiver </div>
                        <div> Receiver </div>
                        <div> Receiver </div>
                    </div>
                </td>

            </tr>
            <tr *ngFor="let i of distribution.distributionInfo">
                <td>
                    <div class="invoice-number" fxLayout="row" fxLayoutAlign="start start">
                        <ngx-barcode [bc-value]="i.label" [bc-margin-left]="50" [bc-height]="35" [bc-width]="3"
                            [bc-display-value]="true"></ngx-barcode>
                        <div> {{i.contact.fullName}} </div>
                        <div> {{i.contact.fullName}} </div>
                        <div> {{i.contact.fullName}} </div>
                        <div> {{i.contact.fullName}} </div>
                    </div>
                </td>
                <td>


                </td>

            </tr> -->
        </div>
        <div class="doNotPrint">
            <button mat-flat-button color="primary" aria-label="back" [routerLink]="'/distributions'">
                <mat-icon>back</mat-icon>
                <span>Back</span>
            </button>
            <button mat-flat-button color="primary" aria-label="print"  (click)="onPrint()">
                <mat-icon>print</mat-icon>
                <span>Print</span>
            </button>
        </div>
    </div>
</div>